import { MESSAGE_LIST_UPDATED } from "../Constants";

export default function (state = [{ type: "text", author: "them", data: { text: "Would you like to chat with a Velocitor Sales agent? Type YES" } }], action) {
    switch (action.type) {
    case MESSAGE_LIST_UPDATED:
        return [...state, action.payload];

    default:
        return state;
    }
}